import BaseAPI from '@/apis/base/baseApi';

export default class SystemApi extends BaseAPI {
  apiName = 'System';
}
